// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"87e75dfa","453":"0ea6490b","796":"9b9456f7"}[chunkId] + ".chunk.js";
};